export { Presenter } from './presenter';

/**
 * @typedef {Object} HasPresenter
 * @property {?Presenter} $presenter
 *
 * @mixin
 */
